import React from 'react'

const WindowWidthContext = React.createContext(null)

export const WindowWidthProvider = WindowWidthContext.Provider
export const WindowWidthConsumer = WindowWidthContext.Consumer
export default WindowWidthContext
